export const normalizeIban = (raw) => String(raw || '').toUpperCase().replace(/[\s-]+/g, '');

export const isValidIban = (raw) => {
  const value = normalizeIban(raw);
  if (value.startsWith('ES') && !/^ES[0-9]{22}$/.test(value)) return false;
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(value)) return false;
  const reordered = `${value.slice(4)}${value.slice(0, 4)}`;
  let remainder = 0;
  for (const character of reordered) {
    const digits = /[A-Z]/.test(character) ? String(character.charCodeAt(0) - 55) : character;
    for (const digit of digits) remainder = ((remainder * 10) + Number(digit)) % 97;
  }
  return remainder === 1;
};

export const supportsContractImprovement = (type) => !['supplies', 'change_ownership'].includes(type);
